document.addEventListener("DOMContentLoaded", function() {
 (function() {
    // Config
    const popupContainer = document.getElementById('popup-container');
    const popupDelay = parseInt(popupContainer.dataset.popupDelay);
    const popupFrequency = parseInt(popupContainer.dataset.popupFrequency);
    const popupTrigger = popupContainer.dataset.popupTrigger;
    
    // Elements
    const popupOverlay = document.getElementById('popup-overlay');
    const closeButtons = document.querySelectorAll(".popup-close");
    const popupSubmit = document.getElementById('popup-submit');
    const popupEmail = document.getElementById('popup-email');
    const newsletterForm = document.getElementById('ContactMarketingPopup');

    // Add a unique ID for each marketing popup 
    const popupId = popupContainer.dataset.popupId || 'default';

    // Register this popup globally so it can be triggered from other components
    if (!window.marketingPopups) {
      window.marketingPopups = {};
    }
    
    window.marketingPopups[popupId] = {
      show: showPopup,
      close: closePopup
    };

    // Check if the newsletter success is from THIS popup or banner click
    // Only show popup on success if it came from marketing popup or banner
    function isMarketingPopupSubmission() {
      const urlParams = new URLSearchParams(window.location.search);
      const hasSuccessParams = urlParams.has('customer_posted') || urlParams.get('form_type') === 'customer';
      const hasMarketingTags = window.location.search.includes('shopifynewsletter') && 
                              window.location.search.includes('Marketing%20Popup');
      const fromBanner = sessionStorage.getItem('popup_triggered_from_banner');
      const hasContactFragment = window.location.hash.includes('ContactMarketingPopup');
      
      return hasSuccessParams && (hasMarketingTags || fromBanner || hasContactFragment);
    }

    // Show popup on newsletter success only if it's from marketing popup or banner
    if (isMarketingPopupSubmission()) {
      // Add body class to hide footer success message
      document.body.classList.add('popup-from-marketing');
      popupContainer.style.display = 'flex';
      popupOverlay.style.display = 'flex';
      
      // Get the submitted email from multiple sources
      const urlParams = new URLSearchParams(window.location.search);
      let submittedEmail = urlParams.get('contact[email]') || 
                          sessionStorage.getItem('popup_submitted_email') ||
                          sessionStorage.getItem('popup_submitted_email_' + popupId);
      
      // Also try to get email from the current URL if it has form data
      if (!submittedEmail) {
        const fullUrl = window.location.href;
        const emailMatch = fullUrl.match(/contact%5Bemail%5D=([^&]+)/);
        if (emailMatch) {
          submittedEmail = decodeURIComponent(emailMatch[1]);
        }
      }
      
      if (submittedEmail && popupEmail) {
        // Set the email in the input field
        popupEmail.value = submittedEmail;
        // Make the input field read-only
        popupEmail.readOnly = true;
        popupEmail.style.cursor = 'default';
       
        // Store the email again for future refreshes
        sessionStorage.setItem('popup_submitted_email_' + popupId, submittedEmail);
      }
      
      // Clear the banner trigger flag but keep email for potential refreshes
      sessionStorage.removeItem('popup_triggered_from_banner');
    }
    
    // Show popup function
    function showPopup() {
      // Set a flag to indicate this popup was triggered from banner/marketing
      sessionStorage.setItem('popup_triggered_from_banner', 'true');
      popupContainer.style.display = 'flex';
      popupOverlay.style.display = 'flex';
      // Save the time when we showed the popup
      localStorage.setItem('popupLastShown_' + popupId, Date.now());
    }
    
    // Close popup function
    function closePopup() {
      popupContainer.style.display = 'none';
      popupOverlay.style.display = 'none';
      // Keep the popup-from-marketing class on body (don't remove it)
      // Clear the stored emails when popup is closed
      sessionStorage.removeItem('popup_submitted_email');
      sessionStorage.removeItem('popup_submitted_email_' + popupId);
      sessionStorage.removeItem('popup_triggered_from_banner');
    }
    
    // Check if we should show the popup
    function shouldShowPopup() {
      const lastShown = localStorage.getItem('popupLastShown_' + popupId);
      
      // If never shown or frequency is set to 0 (always show)
      if (!lastShown || popupFrequency === 0) {
        return true;
      }
      
      // Check if enough time has passed since last show
      const now = Date.now();
      const hoursSinceLastShown = (now - parseInt(lastShown)) / (1000 * 60 * 60);
      
      return hoursSinceLastShown >= popupFrequency;
    }
    
    // Event listeners
    closeButtons.forEach((button) => {
      button.addEventListener("click", closePopup);
    });
    popupOverlay.addEventListener('click', closePopup);
    
    function isValidEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    }

    function markEmailValidation(emailInput) {
      if (!emailInput) return;
      const isValid = isValidEmail(emailInput.value);
      
      if (!isValid) {
        emailInput.classList.add('invalid');
      } else {
        emailInput.classList.remove('invalid');
      }

      return isValid;
    }

    function debounce(func, delay) {
      let timer;
      return function () {
        const context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(context, args), delay);
      };
    }

    if (popupEmail) {
      popupEmail.addEventListener('input', debounce(() => {
        markEmailValidation(popupEmail);
      }, 400));
    }

    if (popupSubmit && popupEmail && newsletterForm) {
      popupSubmit.addEventListener('click', function (e) {
        e.preventDefault(); // prevent native submit
    
        const valid = markEmailValidation(popupEmail);
        if (valid) {
          // Store the email before submission for success display
          sessionStorage.setItem('popup_submitted_email', popupEmail.value);
          // Store with popup ID for persistence
          sessionStorage.setItem('popup_submitted_email_' + popupId, popupEmail.value);
          // Set flag that this submission is from marketing popup
          sessionStorage.setItem('popup_triggered_from_banner', 'true');
          // Add body class immediately to hide footer success message
          document.body.classList.add('popup-from-marketing');
          newsletterForm.submit();
        } else {
          popupEmail.classList.add('invalid');
        }
      });

      // Also listen for form submit event as backup
      newsletterForm.addEventListener('submit', function(e) {
        if (popupEmail && popupEmail.value) {
          sessionStorage.setItem('popup_submitted_email', popupEmail.value);
          sessionStorage.setItem('popup_submitted_email_' + popupId, popupEmail.value);
          sessionStorage.setItem('popup_triggered_from_banner', 'true');
          document.body.classList.add('popup-from-marketing');
        }
      });
    }

    // Initialize popup based on trigger
    if (shouldShowPopup() && !window.location.href.includes('popup_bypass=true')) {
      if (popupTrigger === 'delay') {
        // Show after delay
        setTimeout(showPopup, popupDelay * 1000);
      } else if (popupTrigger === 'scroll') {
        // Show on scroll
        let hasScrolled = false;
        window.addEventListener('scroll', function() {
          if (!hasScrolled) {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollPercentage = (scrollTop / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
            
            if (scrollPercentage >= 30) { // Show after 30% scroll
              showPopup();
              hasScrolled = true;
            }
          }
        });
      } else if (popupTrigger === 'exit_intent') {
        // Show on exit intent
        document.addEventListener('mouseleave', function(e) {
          if (e.clientY < 0) {
            showPopup();
          }
        }, { once: true });
      } else if (popupTrigger === 'manual') {
        // Don't show automatically, will be triggered manually
      } else {
        // Show immediately by default
        showPopup();
      }
    }
  })(); 
});